import { render, staticRenderFns } from "./UserRequestModal.vue?vue&type=template&id=2862ab4c&scoped=true&"
import script from "./UserRequestModal.vue?vue&type=script&lang=js&"
export * from "./UserRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./UserRequestModal.vue?vue&type=style&index=0&id=2862ab4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2862ab4c",
  null
  
)

export default component.exports